import { FunctionComponent } from "react";

import { FrameworkOverrides } from "./types";
import { ChooseFrameworksModal, LanguageAutoDetectRulesModal } from "./modals/BatchModals";

/**
 * The GenerateBar's two MUI `Dialog`-based modals (language auto-detect rules +
 * "Define copywriting" framework chooser). Extracted from {@link GenerateBar} to
 * keep that file under the length gate. Not rendered in the Chrome extension
 * (MUI styles don't cross the shadow boundary) — the caller guards on that.
 */
export const GenerateBarModals: FunctionComponent<{
	showLanguageRulesModal: boolean;
	showFrameworksModal: boolean;
	companyCategory?: string | null;
	personaCategory?: string | null;
	frameworkOverrides: FrameworkOverrides;
	onCloseLanguageRules: () => void;
	onCloseFrameworks: () => void;
	onSaveFrameworks: (overrides: FrameworkOverrides) => void;
}> = ({
	showLanguageRulesModal,
	showFrameworksModal,
	companyCategory,
	personaCategory,
	frameworkOverrides,
	onCloseLanguageRules,
	onCloseFrameworks,
	onSaveFrameworks,
}) => (
	<>
		<LanguageAutoDetectRulesModal
			isOpened={showLanguageRulesModal}
			onClose={onCloseLanguageRules}
		/>
		<ChooseFrameworksModal
			companyCategory={companyCategory}
			initialOverrides={frameworkOverrides}
			isOpened={showFrameworksModal}
			personaCategory={personaCategory}
			onClose={onCloseFrameworks}
			onSave={onSaveFrameworks}
		/>
	</>
);
